﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import * as plugins_qrcode from '../../plugins/qrcode';
import * as nouislider from 'nouislider';

import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../plugins/filepond-plugin-file-encode';
import FilePondPluginImageCrop from '../../plugins/filepond-plugin-image-crop';
import FilePondPluginImageResize from '../../plugins/filepond-plugin-image-resize';
import FilePondPluginImageTransform from '../../plugins/filepond-plugin-image-transform';
import FilePondPluginImagePreview from '../../plugins/filepond-plugin-image-preview';
import FilePondPluginImageEdit from '../../plugins/filepond-plugin-image-edit';
import FilePondPluginImageSizeMetaData from '../../plugins/filepond-plugin-image-size-metadata';
import helper_typo from '../../helper/typo';

import tpl_customQRCodeEditItem from './tpl/customQRCodeEditItem.html';
import tpl_customQRCodeEditItemDesign from './tpl/customQRCodeEditItemDesign.html';

import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_DialogBox from '../../../lib/views/dialogBox/dialogBox';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import config from '../../../common/config';
import View_Render from '../render/render';
import helper_createWebpage from '../../helper/createWebpage';
import Help from '../../helper/help';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';

import View_CustomHeader from '../region/customHeader/customHeader';

export default View_LayoutError.extend({
    designRegion: '#designRegion_modal',
    getTemplate: function () {
        if (this.options.designMode) {
            return tpl_customQRCodeEditItemDesign({ model: this.model.toJSON() });
        } else {
            return tpl_customQRCodeEditItem({ model: this.model.toJSON() });
        }
    },
    regions: {
        information: "#customQRCodeEditItemInformation",
        customHeader: "#customHeader"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.eventId });
        if (customEvent.length > 0) {
            customHeaderModel.attributes.Name = customEvent[0].attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        customHeaderModel.attributes.Title = resources.X100071;
        customHeaderModel.attributes.ShowSave = true;
        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.btnSubmitClick();
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customQRCodeEditItem_btnBack_click();
        });	

        this.localSetting = new Entities_Empty.Model();
        this.localSetting.attributes.EventId = -1;
        this.localSetting.attributes.ImageSelected = false;
    },
    help: function () {
        Help.help(this, true, 'customQRCodeEditItem');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.btnSubmitClick(null, callback);
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        if ((this.model.attributes.Size != this.oldModel.attributes.Size) ||
            (this.model.attributes.Radius != this.oldModel.attributes.Radius) ||
            (this.model.attributes.Quiet != this.oldModel.attributes.Quiet) ||
            (this.model.attributes.Mode != this.oldModel.attributes.Mode) ||
            (this.model.attributes.MSize != this.oldModel.attributes.MSize) ||
            (this.model.attributes.MPosX != this.oldModel.attributes.MPosX) ||
            (this.model.attributes.MPosY != this.oldModel.attributes.MPosY) ||
            (this.model.attributes.Label != this.oldModel.attributes.Label) ||
            (this.model.attributes.FontName != this.oldModel.attributes.FontName) ||
            (this.model.attributes.Fill != this.oldModel.attributes.Fill) ||
            (this.model.attributes.Background != this.oldModel.attributes.Background) ||
            (this.model.attributes.FontColor != this.oldModel.attributes.FontColor) ||
            (this.model.attributes.FontSize != this.oldModel.attributes.FontSize) ||
            (this.model.attributes.FontStyle != this.oldModel.attributes.FontStyle) ||
            (this.model.attributes.Logo != this.oldModel.attributes.Logo)) {
            changes = true;
        }

        this.setHasChanged(changes);
    },
    ui: {
        'customQRCodeEditItem_btnLogo': '#customQRCodeEditItem_btnLogo',
        'customQRCodeEditItem_img_Logo': '#customQRCodeEditItem_img_Logo',
        'customQRCodeEditItem_inputName': '#customQRCodeEditItem_inputName',
        'customQRCodeEditItem_btnSubmit': '#customQRCodeEditItem_btnSubmit',
        'customQRCodeEditItem_input_Size': '#customQRCodeEditItem_input_Size',
        'customQRCodeEditItem_ColorPickerSliders_Fill': '#customQRCodeEditItem_ColorPickerSliders_Fill',
        'customQRCodeEditItem_ColorPickerSliders_Background': '#customQRCodeEditItem_ColorPickerSliders_Background',
        'customQRCodeEditItem_input_Quiet': '#customQRCodeEditItem_input_Quiet',
        'customQRCodeEditItem_input_Radius': '#customQRCodeEditItem_input_Radius',
        'customQRCodeEditItem_select_Mode': '#customQRCodeEditItem_select_Mode',
        'customQRCodeEditItem_input_MSize': '#customQRCodeEditItem_input_MSize',
        'customQRCodeEditItem_input_MPosX': '#customQRCodeEditItem_input_MPosX',
        'customQRCodeEditItem_input_MPosY': '#customQRCodeEditItem_input_MPosY',
        'customQRCodeEditItem_input_Label': '#customQRCodeEditItem_input_Label',
        'customQRCodeEditItem_select_FontName': '#customQRCodeEditItem_select_FontName',
        'customQRCodeEditItem_dropDown_FontSize': '#customQRCodeEditItem_dropDown_FontSize',
        'customQRCodeEditItem_select_FontStyle': '#customQRCodeEditItem_select_FontStyle',
        'customQRCodeEditItem_ColorPickerSliders_FontColor': '#customQRCodeEditItem_ColorPickerSliders_FontColor',
        'customQRCodeEditItem_select_Logo': '#customQRCodeEditItem_select_Logo',
        'customQRCodeEditItem_qrCodeContainer': '#customQRCodeEditItem_qrCodeContainer',
        'customQRCodeEditItem_container': '#customQRCodeEditItem_container',
        'customQRCodeEditItem_qrCodeLogo': '#customQRCodeEditItem_qrCodeLogo',
        'help': '#help',
        'designRegion_body': '#designRegion_body',
        'designRegion_btnOk': '#designRegion_btnOk',
        'customAdImageInsert_filePond': '#customAdImageInsert_filePond',
        'customQRCodeEditItem_inputNameGroup': '#customQRCodeEditItem_inputNameGroup',
        'customQRCodeEditItem_btnBack': '#customQRCodeEditItem_btnBack',
        'customAdImageInsert_image': '#customAdImageInsert_image',
        'customAdImageInsert_btn_crop_zoom_plus': '#customAdImageInsert_btn_crop_zoom_plus',
        'customAdImageInsert_btn_crop_zoom_minus': '#customAdImageInsert_btn_crop_zoom_minus',
        'customAdImageInsert_btn_crop_move_left': '#customAdImageInsert_btn_crop_move_left',
        'customAdImageInsert_btn_crop_move_right': '#customAdImageInsert_btn_crop_move_right',
        'customAdImageInsert_btn_crop_move_top': '#customAdImageInsert_btn_crop_move_top',
        'customAdImageInsert_btn_crop_move_buttom': '#customAdImageInsert_btn_crop_move_buttom',
        'customAdImageInsert_btn_crop_rotate_left': '#customAdImageInsert_btn_crop_rotate_left',
        'customAdImageInsert_btn_crop_rotate_right': '#customAdImageInsert_btn_crop_rotate_right',
        'customAdImageInsert_btn_crop_scale_x': '#customAdImageInsert_btn_crop_scale_x',
        'customAdImageInsert_btn_crop_scale_y': '#customAdImageInsert_btn_crop_scale_y',
        'customAdImageInsert_btn_crop_aspectRatio_5_5': '#customAdImageInsert_btn_crop_aspectRatio_5_5',
        'customAdImageInsert_btn_crop_aspectRatio_4_3': '#customAdImageInsert_btn_crop_aspectRatio_4_3',
        'customAdImageInsert_btn_crop_aspectRatio_3_4': '#customAdImageInsert_btn_crop_aspectRatio_3_4',
        'customAdImageInsert_btn_crop_aspectRatio_6_4': '#customAdImageInsert_btn_crop_aspectRatio_6_4',
        'customAdImageInsert_btn_crop_aspectRatio_4_6': '#customAdImageInsert_btn_crop_aspectRatio_4_6',
        'customAdImageInsert_btn_crop_aspectRatio_Free': '#customAdImageInsert_btn_crop_aspectRatio_Free',
        'customAdSetting_btnAd': '#customAdSetting_btnAd',
        'customAdSetting_btnDelete': '#customAdSetting_btnDelete'
    },
    events: {
        'click @ui.customQRCodeEditItem_btnSubmit': 'btnSubmitClick',
        'change @ui.customQRCodeEditItem_input_Size': 'updateQrCode',
        'change @ui.customQRCodeEditItem_ColorPickerSliders_Fill': 'updateQrCode',
        'change @ui.customQRCodeEditItem_ColorPickerSliders_Background': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_Quiet': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_Radius': 'updateQrCode',
        'change @ui.customQRCodeEditItem_select_Mode': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_MSize': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_MPosX': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_MPosY': 'updateQrCode',
        'change @ui.customQRCodeEditItem_input_Label': 'updateQrCode',
        'change @ui.customQRCodeEditItem_select_FontName': 'updateQrCode',
        'change @ui.customQRCodeEditItem_ColorPickerSliders_FontColor': 'updateQrCode',
        'change @ui.customQRCodeEditItem_select_Logo': 'updateLogo',
        'change @ui.customQRCodeEditItem_select_FontStyle': 'updateLogo',
        'change @ui.customQRCodeEditItem_dropDown_FontSize': 'updateLogo',
        'keyup @ui.customQRCodeEditItem_input_Label': 'updateQrCode',
        'paste @ui.customQRCodeEditItem_input_Label': 'updateQrCode',
        'click #help': 'help',
        'click @ui.designRegion_btnOk': 'designRegion_btnOk',
        'colorpickerChange @ui.customQRCodeEditItem_ColorPickerSliders_Fill': 'colorChange_Fill',
        'colorpickerChange @ui.customQRCodeEditItem_ColorPickerSliders_Background': 'colorChange_Background',
        'colorpickerChange @ui.customQRCodeEditItem_ColorPickerSliders_FontColor': 'colorChange_FontColor',
        'click @ui.customQRCodeEditItem_btnBack': 'customQRCodeEditItem_btnBack_click',   

        'click @ui.customQRCodeEditItem_btnLogo': 'customQRCodeEditItem_btnLogoClick',
        'click @ui.customAdSetting_btnAd': 'customAdSetting_btnAdClick',
        'click @ui.customAdSetting_btnDelete': 'customAdSetting_btnDeleteClick',
        'click @ui.customAdImageInsert_btn_crop_zoom_plus': 'btnZoomPlusClick',
        'click @ui.customAdImageInsert_btn_crop_zoom_minus': 'btnZoomMinusClick',
        'click @ui.customAdImageInsert_btn_crop_move_left': 'btnMoveLeftClick',
        'click @ui.customAdImageInsert_btn_crop_move_right': 'btnMoveRightClick',
        'click @ui.customAdImageInsert_btn_crop_move_top': 'btnMoveTopClick',
        'click @ui.customAdImageInsert_btn_crop_move_buttom': 'btnMoveButtomClick',
        'click @ui.customAdImageInsert_btn_crop_rotate_left': 'btnRotateLeftClick',
        'click @ui.customAdImageInsert_btn_crop_rotate_right': 'btnRotateRightClick',
        'click @ui.customAdImageInsert_btn_crop_scale_x': 'btnScaleXClick',
        'click @ui.customAdImageInsert_btn_crop_scale_y': 'btnScaleYClick',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_5_5': 'btnAspectRatio_5_5_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_4_3': 'btnAspectRatio_4_3_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_3_4': 'btnAspectRatio_3_4_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_6_4': 'btnAspectRatio_6_4_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_4_6': 'btnAspectRatio_4_6_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_Free': 'btnAspectRatio_Free_Click'
    },
    customQRCodeEditItem_btnLogoClick() {
        this.setupFancyBoxImg();
    },
    setupFancyBoxImgLoad() {

        this.model.attributes.Logo = this.ui.customQRCodeEditItem_select_Logo.val();
        if (this.model.attributes.Logo == '/images/Events4us.png') {
            var src = this.model.attributes.Logo;
        }
        else {
            //var model = self.app.entities.collections.customImage.fullCollection.where({ id: parseInt(this.model.attributes.Logo) })[0];
            //var src = model.attributes.ImageUrl;
            var src = this.model.attributes.Logo;
        }

        this.ui.customQRCodeEditItem_img_Logo.attr('src', src);
    },
    setupFancyBoxImg() {
        var self = this;
        var list = [];

        if (this.model.attributes.Logo == '/images/Events4us.png') {
            var src = this.model.attributes.Logo;
        }
        else {
            var model = self.app.entities.collections.customImage.fullCollection.where({ id: parseInt(this.model.attributes.Logo) })[0];

            if (model != undefined) {
                var src = model.attributes.ImageUrl;

            }
        }

        var item = {
            src: src,
            opts: {
                caption: '',
                thumb: "'" + src + "'"
            }
        }

        list.push(item);

        if (this.model.attributes.Logo != '/images/Events4us.png') {
            var src = '/images/Events4us.png';

            var item = {
                src: src,
                opts: {
                    caption: '',
                    thumb: "'" + src + "'"
                }
            }

            list.push(item);
        }

        this.app.entities.collections.customImage.fullCollection.models.forEach(function (entry) {
            var s;

            if (self.model.attributes.Logo != entry.attributes.id) {
                var item = {
                    src: entry.attributes.ImageUrl,
                    opts: {
                        caption: '',
                        thumb: "'" + entry.attributes.ImageUrl + "'"
                    }
                }

                list.push(item);
            }
        });

        $.fancybox.open(
            list,
            {

                loop: false,
                thumbs: {
                    autoStart: true, // Display thumbnails on opening
                    hideOnClose: true, // Hide thumbnail grid when closing animation starts
                    parentEl: ".fancybox-container", // Container is injected into this element
                    axis: "y" // Vertical (y) or horizontal (x) scrolling
                },
                opts: {

                },
                beforeClose: function (instance, current) {
                    

                    if (current.src == '/images/Events4us.png') {
                        self.model.attributes.Logo = current.src;
                    }
                    else {
                        var model = self.app.entities.collections.customImage.fullCollection.where({ ImageUrl: current.src })[0];
                        self.model.attributes.Logo = model.attributes.id.toString();;
                    }
                    self.ui.customQRCodeEditItem_img_Logo.attr('src', current.src);
                    self.updateLogo();
                    self.updateQrCode();
                },
                clickContent: "close",
                clickSlide: "close",
                clickOutside: "close"
            }
        );

        this.setupFancyBoxStyle();
    },
    setupFancyBoxStyle() {
        var top = window.innerHeight * 0.1;
        var left = window.innerWidth * 0.1;
        $('.fancybox-container').css('max-width', '80%');
        $('.fancybox-container').css('max-height', '80%');
        $('.fancybox-container').css('left', left + 'px');
        $('.fancybox-container').css('top', top + 'px');
    },
    colorChange_Fill: function (e) {
        this.model.attributes.Fill = e.value.toRgbString();
        this.updateQrCode();
    },
    colorChange_Background: function (e) {
        this.model.attributes.Background = e.value.toRgbString();
        this.updateQrCode();
    },
    colorChange_FontColor: function (e) {
        this.model.attributes.FontColor = e.value.toRgbString();
        this.updateQrCode();
    },
    onRender: function () {
        this.ui.customQRCodeEditItem_select_Mode.val(this.model.attributes.Mode);

        //this.insertLogo(this.ui.customQRCodeEditItem_select_Logo);
        

        this.renderInformation();

        if (this.app.mode == 1) {
            this.ui.customQRCodeEditItem_inputNameGroup.css('display', 'none');
            this.ui.customQRCodeEditItem_btnSubmit.css('display', 'none');
            this.ui.customQRCodeEditItem_btnBack.css('display', 'none');
        }

        this.setupFont();
        this.setupFontStyle();
        this.setupFontSize();
        
        this.ui.customQRCodeEditItem_img_Logo.attr('src', this.model.attributes.Logo);

        //this.setupLogo();

        //this.setupFancyBoxImgLoad();
    },
    setupFont: function () {
        var self = this;

        var fonts = [];

        self.app.entities.collections.Font.forEach(function (entry) {
            fonts.push(entry.attributes.data_font_family);
        });

        this.ui.customQRCodeEditItem_select_FontName.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.set({ FontName: this.value });
        });
        this.ui.customQRCodeEditItem_select_FontName.trigger('setFont', self.model.attributes.FontName);
    },
    setupFontSize: function () {
        var self = this;

        this.ui.customQRCodeEditItem_dropDown_FontSize.empty();

        var selected = '';

        for (var i = 10; i <= 200; i++) {
            selected = '';

            if (self.model.attributes.FontSize == String.format('{0}{1}', i, 'px')) {
                selected = 'selected = "selected"';
            }

            var options = String.format('<option {1}>{0}px</option>', i, selected);
            this.ui.customQRCodeEditItem_dropDown_FontSize.append(options);
        }
    },
    setupFontStyle: function () {
        var self = this;
        self.ui.customQRCodeEditItem_select_FontStyle.empty();

        var selected = '';

        self.app.entities.collections.QRCodeFontStyle.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.FontStyle == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customQRCodeEditItem_select_FontStyle.append(options);
        });
    },
    renderInformation: function () {
        this.informationCollection.reset();

        var tmpModel = new this.informationCollection.model({ Information: resources.X100072 });
        this.informationCollection.add(tmpModel);

    },
    customViewEvent_setActive: function () {
        var array = [];

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ QRCode: this.model.attributes.id });

        if (customEvent && customEvent.length > 0) {
            customEvent.forEach(function (entry) {
                var tmp = { "id": entry.attributes.id };
                array.push(tmp);
            });
        }

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach() {
        var self = this;

        this.customViewEvent_setActive();

        this.updateLogo();

        if ($("#customQRCodeEditItem_input_Size").length) {
            var startSlider1 = document.getElementById('customQRCodeEditItem_input_Size');
            nouislider.create(startSlider1, {
                start: self.model.attributes.Size,
                connect: [true, false],
                range: {
                    min: 150,
                    max: 600
                },
                step : 50
            });
            startSlider1.noUiSlider.on('set', function (e) {
                self.model.attributes.Size = parseInt(e);
                self.updateQrCode();
            });
        }

        if ($("#customQRCodeEditItem_input_MSize").length) {
            var startSlider2 = document.getElementById('customQRCodeEditItem_input_MSize');
            nouislider.create(startSlider2, {
                start: self.model.attributes.MSize,
                connect: [true, false],
                range: {
                    min: 0,
                    max: 35
                },
                step: 1
            });
            startSlider2.noUiSlider.on('set', function (e) {
                self.model.attributes.MSize = parseInt(e);
                self.updateQrCode();
            });
        }

        if ($("#customQRCodeEditItem_input_MPosX").length) {
            var startSlider3 = document.getElementById('customQRCodeEditItem_input_MPosX');
            nouislider.create(startSlider3, {
                start: self.model.attributes.MPosX,
                connect: [true, false],
                range: {
                    min: 0,
                    max: 100
                },
                step: 1
            });
            startSlider3.noUiSlider.on('set', function (e) {
                self.model.attributes.MPosX = parseInt(e);
                self.updateQrCode();
            });
        }

        if ($("#customQRCodeEditItem_input_MPosY").length) {
            var startSlider4 = document.getElementById('customQRCodeEditItem_input_MPosY');
            nouislider.create(startSlider4, {
                start: self.model.attributes.MPosY,
                connect: [true, false],
                range: {
                    min: 0,
                    max: 100
                },
                step: 1
            });
            startSlider4.noUiSlider.on('set', function (e) {
                self.model.attributes.MPosY = parseInt(e);
                self.updateQrCode();
            });
        }

        this.ui.customQRCodeEditItem_ColorPickerSliders_Fill.colorpicker({
            color : self.model.attributes.Fill,
            format: "rgb"
        });

        this.ui.customQRCodeEditItem_ColorPickerSliders_Background.colorpicker({
            color: self.model.attributes.Background,
            format: "rgb"
        });

        this.ui.customQRCodeEditItem_ColorPickerSliders_FontColor.colorpicker({
            color: self.model.attributes.FontColor,
            format: "rgb"
        });
        
        if (this.options.designMode) {
            var height = $(window).height() * 0.8;
            this.ui.designRegion_body.height(height);
        }

        var self = this;
        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginImageCrop,
            FilePondPluginImageResize,
            FilePondPluginImageTransform,
            FilePondPluginImagePreview,
            FilePondPluginImageEdit,
            FilePondPluginImageSizeMetaData
        );

        var labelIdle = resources.X101435 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.customAdImageInsert_filePond[0], {
            labelIdle: [
                labelIdle,
                ''
            ],
            allowMultiple: false,
            //allowReorder: true,
            allowFileEncode: true,
            //allowImageCrop: true,
            //imageCropAspectRatio:"1:1",
            //allowImageResize: true,
            //imageResizeTargetWidth: 750,
            //imageResizeTargetHeight: 750,
            imageResizeMode: 'contain',
            //imageResizeUpscale: true,
            //imageCropAspectRatio: 1,
            allowImageTransform: true,
            //allowImagePreview: true,
            //allowImageEdit:true,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    var base64 = fileItem.getFileEncodeDataURL();

                    self.localSetting.attributes.ImageSelected = true;

                    if (self.cropper) {
                        self.cropper.destroy();
                    }
                    self.ui.customAdImageInsert_image.attr('src', base64);
                    //self.ui.customImageInsert_roundImage.attr('src', base64);

                    //var mimeType = self.base64MimeType(base64);
                    //var fileData = base64.split(',')[1];

                    self.localSetting.attributes.FileName = fileItem.filenameWithoutExtension;
                    self.localSetting.attributes.FileName = helper_typo.getUTCUnicDataTimrId();

                    var previews = document.querySelectorAll('.cropper-img-preview');
                    var imageDefault = document.querySelector('#customAdImageInsert_image');

                    self.cropper = new Cropper(imageDefault, {
                        aspectRatio: 1 / 1,
                        autoCropArea: 1,
                        zoomOnTouch: false,
                        zoomOnWheel: false,
                        cropBoxResizable: true,
                        build: function () {
                            var clone = this.cloneNode();

                            clone.style.cssText = (
                                'display: block;' +
                                'width: 100%;' +
                                'minWidth: 0;' +
                                'minHeight: 0;' +
                                'maxWidth: none;' +
                                'maxHeight: none;'
                            );
                        },

                        crop: function (e) {
                            var data = e.detail;
                            var cropper = this.cropper;
                            var imageData = cropper.getImageData();
                            var previewAspectRatio = data.width / data.height;
                        }
                    });

                    //self.setupBtn();

                    pond.removeFile(fileItem);
                };
            }
        });
    },
    onDestroy(){
    },
    validate: function () {
        var self = this;
        //var oldname = this.model.attributes.Name;

        //this.model.attributes.Name = this.ui.customQRCodeEditItem_inputName.val();

        var modelErrors = this.model.validateNoBackbone(app);
        if (modelErrors) {
            this.showErrors(this.model.errors);
            //this.model.attributes.Name = oldname;
            return false;
        }
        else {
            this.hideErrors();
        }

        return true;
    },
    oldbtnSubmitClick: function (event, callbackMenu) {
        var self = this;
        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100071;
        dialogWaitingModel.attributes.Text = resources.X100307;
        dialogWaitingModel.attributes.Button = resources.X100279;

                
        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        var callback = function (options) {
            this.stopListening(dialogWaiting, "dialog:okclicked", callback);

            setTimeout(function() {
                // rest of code here
                var dialog2ButtonModel = new Entities_Empty.Model();
                dialog2ButtonModel.attributes.Title = resources.X100229;
                dialog2ButtonModel.attributes.Text = resources.X100395;
                dialog2ButtonModel.attributes.Button01 = resources.X100281;
                dialog2ButtonModel.attributes.Button02 = resources.X100282;
                var dialog2Buttonbla = new View_Dialog2Button({ model: dialog2ButtonModel, parent: self });
                var callback01bla = function (options) {
                    self.stopListening(dialog2Buttonbla, "dialog:btn01clicked", callback01bla);
                    self.stopListening(dialog2Buttonbla, "dialog:btn02clicked", callback02bla);
                }
                self.listenTo(dialog2Buttonbla, "dialog:btn01clicked", callback01bla);

                var callback02bla = function (options) {
                    self.stopListening(dialog2Buttonbla, "dialog:btn01clicked", callback01bla);
                    self.stopListening(dialog2Buttonbla, "dialog:btn02clicked", callback02bla);

                    callback();
                }
                self.listenTo(dialog2Buttonbla, "dialog:btn02clicked", callback02bla);

                self.app.dialogRegion.show(dialog2Buttonbla);
            }, 2000);

        }
        this.listenTo(dialogWaiting, "dialog:okclicked", callback);

        self.app.dialogRegion.show(dialogWaiting);
    },
    btnSubmitClick: function (event, callbackMenu) {
        if (event != null) {
            event.preventDefault();
        }
        var self = this;
        if (this.validate()) {
            this.updateQrCode();
            this.setHasChanged(false);

            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100071;
            dialogWaitingModel.attributes.Text = resources.X100307;
            dialogWaitingModel.attributes.Button = resources.X100279;
                
            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
            var callback = function (options) {
                this.stopListening(dialogWaiting, "dialog:okclicked", callback);
            }
            this.listenTo(dialogWaiting, "dialog:okclicked", callback);

            self.app.dialogRegion.show(dialogWaiting);

            self.model.save(this.model.attributes, {
                silent: true,
                success: function () {
                    self.oldModel = self.model.clone();

                    dialogWaiting.triggerMethod('dialog:close');
                    self.collection.fullCollection.sort();
                    self.collection.getFirstPage({ fetch: false });

                    var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.model.attributes.EventId })
                    var render = new View_Render({ collection: customEvent, app : self.app });
                    self.app.renderRegion.show(render);
                    var renderFinishCallback = function (options) {
                        if (callbackMenu) {
                            callbackMenu();
                        }
                        //self.app.router.customQRCode();
                        //var url = 'customQRCode';
                        //self.app.router.navigate(url);
                    }
                    //render.doIt(renderFinishCallback, false, 'EVENTINFO_SCHEMASCREEN_POSTER_REFRESH', false);
                    render.doIt(renderFinishCallback, false, 'EVENTINFO_REFRESH', false);
                } 
            });
        }
    },
    insertLogo: function (element) {
        var self = this;

        element.append('<option value="' + '/images/Events4us.png' + '">' + 'Events4us' + '</option>');

        this.app.entities.collections.customImage.fullCollection.forEach(function (entry) {
            if (self.model.attributes.Logo == entry.attributes.id) {
                element.append('<option value="' + entry.attributes.id + '" selected="selected">' + entry.attributes.Name + '</option>');
            }
            else {
                element.append('<option value="' + entry.attributes.id + '">' + entry.attributes.Name + '</option>');
            }
        });
    },
    updateLogo: function (event) {

        if (event !=  null) {
            this.setHasChanged(true);
        }

        //this.model.attributes.Logo = this.ui.customQRCodeEditItem_select_Logo.val();

        /*if (this.model.attributes.Logo == '/images/Events4us.png') {
            var src = this.model.attributes.Logo;
        }
        else {
            var model = this.app.entities.collections.customImage.fullCollection.where({ id: parseInt(this.model.attributes.Logo) })[0];

            if (model != undefined) {
                var src = model.attributes.ImageUrl;
            }

            //var src = config.webApiUrl() + '/api/PublicCustomImage/route01/' + this.model.attributes.Logo;

        }*/

        var self = this;
        this.ui.customQRCodeEditItem_qrCodeLogo.off("load");
        //JQUpdate
        //this.ui.customQRCodeEditItem_qrCodeLogo.load(function () {
        this.ui.customQRCodeEditItem_qrCodeLogo.on('load', function () {
            self.updateQrCode();
            self.ui.customQRCodeEditItem_qrCodeLogo.off("load");
        });
        this.ui.customQRCodeEditItem_qrCodeLogo.attr("src", this.model.attributes.Logo /*src*/);
    },
    updateQrCode: function () {
        //this.model.attributes.Size = parseInt(this.ui.customQRCodeEditItem_input_Size.val(), 10);
        //this.model.attributes.Radius = parseInt(this.ui.customQRCodeEditItem_input_Radius.val(), 10);
        //this.model.attributes.Quiet = parseInt(this.ui.customQRCodeEditItem_input_Quiet.val(), 10);
        this.model.attributes.Mode = parseInt(this.ui.customQRCodeEditItem_select_Mode.val());
        //this.model.attributes.MSize = parseInt(this.ui.customQRCodeEditItem_input_MSize.val(), 10);
        //this.model.attributes.MPosX = parseInt(this.ui.customQRCodeEditItem_input_MPosX.val(), 10);
        //this.model.attributes.MPosY = parseInt(this.ui.customQRCodeEditItem_input_MPosY.val(), 10);
        this.model.attributes.Label = this.ui.customQRCodeEditItem_input_Label.val();
        //this.model.attributes.FontName = this.ui.customQRCodeEditItem_select_FontName.val();
        //this.model.attributes.Logo = //this.ui.customQRCodeEditItem_select_Logo.val();
        this.model.attributes.FontStyle = parseInt(this.ui.customQRCodeEditItem_select_FontStyle.val());
        this.model.attributes.FontSize = this.ui.customQRCodeEditItem_dropDown_FontSize.val();

        this.ui.customQRCodeEditItem_container.empty();

        var tmpModelQRCode = new Entities_Empty.Model();
        //tmpModelQRCode.attributes.id = -1;

        var tmpModelQRCode = helper_createWebpage.createQRCodeImage(this.model, tmpModelQRCode, this.ui.customQRCodeEditItem_qrCodeLogo, this.ui.customQRCodeEditItem_qrCodeContainer, false, this.app);

        this.model.attributes.ImageData = tmpModelQRCode.attributes.ImageData;
        this.model.attributes.ImageMimeType = tmpModelQRCode.attributes.ImageMimeType;
        this.model.attributes.ImageUpdate = tmpModelQRCode.attributes.ImageUpdate;
        this.model.attributes.Filename = this.model.attributes.Name + '_' + new Date().getTime() + '.jpg';
    },
    designRegion_btnOk() {
        this.triggerMethod('dialog:close');
    },
    customQRCodeEditItem_btnBack_click: function (event) {
        this.app.router.navigate("#customEventEditItem?id=" + this.options.eventId, { trigger: true });
        this.app.router.customEventEditItem(this.options.eventId, this.options.scroll, 1, false, false);
    },
    customAdSetting_btnAdClick() {
        var self = this;
        //this.setupFancyBoxAd();

        var searchString = ";base64,";
        var pos = 0;
        var uuid = this.UUID();

        var strUtcDate = helper_typo.getDBUtcDataTime();

        var image515 = this.getWeboptimizeImage(750, 750);

        var imageData512 = image515.data;
        pos = imageData512.indexOf(searchString);
        var imageMimeType512 = imageData512.substring(5, pos);
        imageData512 = imageData512.substring(pos + searchString.length, imageData512.length);

        var sizeText = Math.round(image515.width) + 'X' + Math.round(image515.height);

        var filename = resources.X101451 + " - " + this.localSetting.attributes.FileName;
        var filename = helper_typo.getUTCUnicDataTimrId();



        var callbackSaveImage = function (tmpModel) {
            var model = self.app.entities.collections.customImage.fullCollection.where({ id: tmpModel.attributes.id })[0];
            self.model.attributes.Logo = model.attributes.ImageUrl;
            self.ui.customQRCodeEditItem_img_Logo.attr('src', model.attributes.ImageUrl + '?bust=' + strUtcDate);

            self.updateLogo();
            self.updateQrCode();

            self.model.save(self.model.attributes, {
                silent: true,
                wait: true,
                success: function () {
                }
            });
        }


        this.saveImage(filename, resources.X100500, resources.X101289, imageData512, imageMimeType512, 1, sizeText, 0, uuid, strUtcDate, callbackSaveImage);

    },
    saveImage: function (filename, filenameText, nameText, imageData, imageMimeType, sizeType, sizeText, sortType, uuid, strUtcDate, callback) {
        var searchString = ";base64,";
        var pos = 0;

        //var imageDataOriginal = this.getOriginalImage();
        //pos = imageDataOriginal.indexOf(searchString);
        //var imageMimeTypeOriginal = imageDataOriginal.substring(5, pos);
        //imageDataOriginal = imageDataOriginal.substring(pos + searchString.length, imageDataOriginal.length);

        var tmpModel = new this.collection.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.Name = filename;//this.ui.customImageInsert_inputName.val();// + ' ' + nameText;
        tmpModel.attributes.ImageData = imageData;
        tmpModel.attributes.ImageMimeType = 'image/png'; //imageMimeType;
        tmpModel.attributes.ImageUpdate = true;
        tmpModel.attributes.EventId = this.options.eventId;
        tmpModel.attributes.SizeType = sizeType;
        tmpModel.attributes.SizeText = sizeText;
        tmpModel.attributes.SortType = sortType;
        tmpModel.attributes.CommonId = uuid;
        tmpModel.attributes.UtcDate = strUtcDate;

        //tmpModel.attributes.Filename = filename + '_' + filenameText + '.jpg';
        tmpModel.attributes.Filename = filename + '.png';//'_' + filenameText + '.png';

        this.collection.fullCollection.create(tmpModel, {
            wait: true,
            success: function (response) {
                callback(tmpModel);
            }
        });
    },
    customAdSetting_btnDeleteClick() {
        var self = this;
        if (self.model.attributes.Logo != '/images/Events4us.png') {
            var self = this;
            var model = self.app.entities.collections.customImage.fullCollection.where({ ImageUrl: self.model.attributes.Logo })[0];

            model.destroy({
                wait: true,
                success: function (model, response) {
                    self.model.attributes.Logo = '/images/Events4us.png';

                    self.ui.customQRCodeEditItem_img_Logo.attr('src', self.model.attributes.Logo);

                    self.model.save(self.model.attributes, {
                        silent: true,
                        wait: true,
                        success: function () {
                            self.updateLogo();
                            self.updateQrCode();
                        }
                    });
                },
                error: function (model, response) {
                }
            });
        }
    },
    btnZoomPlusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(0.1);
    },
    btnZoomMinusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(-0.1);
    },
    btnMoveLeftClick: function (event) {
        event.preventDefault();
        this.cropper.move(-10, 0);
    },
    btnMoveRightClick: function (event) {
        event.preventDefault();
        this.cropper.move(10, 0);
    },
    btnMoveTopClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, -10);
    },
    btnMoveButtomClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, 10);
    },
    btnRotateLeftClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(-90);
    },
    btnRotateRightClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(90);
    },
    btnScaleXClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleX) {
            case 1: this.cropper.scaleX(-1); break;
            case -1: this.cropper.scaleX(1); break;
        }
    },
    btnScaleYClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleY) {
            case 1: this.cropper.scaleY(-1); break;
            case -1: this.cropper.scaleY(1); break;
        }
    },
    btnAspectRatio_5_5_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(1);
    },
    btnAspectRatio_4_3_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(4 / 3);
    },
    btnAspectRatio_3_4_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(3 / 4);
    },
    btnAspectRatio_6_4_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(6 / 4);
    },
    btnAspectRatio_4_6_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(4 / 6);
    },
    btnAspectRatio_Free_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(NaN);
    },
    getWeboptimizeImage: function (width, height) {
        if (this.cropper) {
            //Calc height
            var cropBoxData = this.cropper.getCropBoxData();
            var aspectRatio = cropBoxData.height / cropBoxData.width;
            height = width * aspectRatio;

            var croppedCanvas;
            var canvas;
            var image;

            // Crop
            croppedCanvas = this.cropper.getCroppedCanvas();

            // Round
            canvas = this.getWeboptimizeCanvas(croppedCanvas, width, height);

            var struct = {
                width: width,
                height: height,
                data: canvas.toDataURL('image/png', 0.5)
            }

            return struct;//canvas.toDataURL();
            //return canvas.toDataURL();
        }
    },
    UUID: function () {
        var lut = [];
        for (var i = 0; i < 256; i++) {
            lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
        }

        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;

        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
            lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
            lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
            lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    },
    getWeboptimizeCanvas: function (sourceCanvas, width, height) {
        var canvas = document.createElement('canvas');

        var context = canvas.getContext('2d');

        canvas.width = width;
        canvas.height = height;
        context.beginPath();
        context.drawImage(sourceCanvas, 0, 0, width, height);

        return canvas;
    }
}, Backbone.Radio.Requests);